<template>
  <div class="container">
    <van-nav-bar title="搜索" left-text="" left-arrow @click-left="onClickLeft">
      <template #right>
        <van-icon name="scan" size="18" @click="scanQRCode" />
      </template>
    </van-nav-bar>
    <div>
      <van-search
        v-model="keyword"
        show-action
        shape="round"
        background="none"
        label=""
        placeholder="请输入充值订单编号、退款单号、手机号码、设备编号"
        @search="onSearch"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
    </div>
    <div class="menu">
      <div class="menuitem" @click="showPicker(1)">
        {{communityName || '所属项目'}}
        <img class="icon" src="@/assets/img/sel_dc.png" />
      </div>
      <div class="menuitem" @click="showPicker(2)">
        {{searchTime || '时间'}}
        <img class="icon" src="@/assets/img/sel_dc.png" />
      </div>
      <div class="menuitem" @click="showPicker(3)">
        {{searchType || '搜索类型'}}
        <img class="icon" src="@/assets/img/sel_dc.png" />
      </div>
    </div>
    <van-popup v-model="showPopup" :close-on-click-overlay='false' round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        value-key="name"
        @cancel="onCancel"
        @confirm="onConfirm"
        @change="onChange"
      />
    </van-popup>
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="projectList.length > 0?'没有更多了':'暂无数据'"
      @load="onLoad" v-if="isSearch"
    >
      <div class="list-box">
        <div v-if="type=='Device'">
        <div class="list clearfix" :key="index" v-for="(item,index) in projectList" @click="changePage2(item)">
          <div class="flex mg10">
            <div>设备编号：{{item.mainNo}}</div>
            <div><span :class="item.statusDesc == '禁用'?'bg_c':'bg_b'" class="dian"></span> {{item.statusDesc}}</div>
          </div>
          <div class="bold mg10">{{item.fullCommunityName}}</div>
          <div class="flex mg10">
            <div>位置：{{item.location}}</div>
            <div><van-switch :value="item.isEnabled" size="20px" disabled/></div>
          </div>
          <div class="bold mg10">{{item.lastOnTime}}</div>
                <div>
                  <span class="col_b">充电中({{item.chargingCount}})</span>
                  <span class="fg"></span>
                  <span>空闲({{item.freeCount}})</span>
                  <span class="fg"></span>
                  <span class="col_r">故障({{item.errorCount}})</span>
                </div>
                <div class="col_b" style="position:absolute;right:10px;margin-top:-20px">详情</div>
        </div>
        </div>
        <div v-else>
        <div class="list" @click="changePage(item)" :key="index" v-for="(item,index) in projectList">
          <div class="flex mg10">
            <div>
              <span class="lab">所属项目：</span>
              {{item.communityName}}
            </div>
            <div>
              <van-tag type="primary" size="large" v-if="item.queryType==1">充值记录</van-tag>
              <van-tag type="warning" size="large" v-if="item.queryType==2">退款记录</van-tag>
              <van-tag type="success" size="large" v-if="item.queryType==3">充电记录</van-tag>
            </div>
          </div>

          <div class="flex mg10">
            <div>
              <span class="lab">手机号码：</span>{{item.mobile}}
            </div>
            <div class="col_o blod val">￥{{item.amount/100}}</div>
          </div>
          <div class="flex mg10">
            <div>
              <span class="lab">{{item.queryType==2?'平台退款单号：':'订单编号：'}}</span>{{item.orderId}}
            </div>
          </div>
          
          <div class="flex mg10">
            <div>
              <span class="lab" v-if="item.queryType==1">订单时间</span>
              <span class="lab" v-if="item.queryType==2">申请退款时间</span>
              <span class="lab" v-if="item.queryType==3">扫码时间</span>
              {{item.createTime}}
            </div>
            <div class="col_b">详情</div>
          </div>
          <div class="flex">
            <div>
              <span class="lab" v-if="item.queryType==3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;状态：</span>{{item.statusDesc}}
            </div>
          </div>
        </div>
        </div>
      </div>

    </van-list>  

  </div>
</template>

<script>
  import axios from '@/axios.js';
    import Vue from 'vue';
  import moment from "moment";
  import {NavBar,Icon,Image,Toast,Loading,Picker,Field,Popup,List,search,tag,Collapse, CollapseItem,Grid,GridItem,Switch} from 'vant';
  export default {
    data() {
      return {
        keyword:'',
        isSearch:false,
        searchType:'',
        searchTime:'',
        startTime:'',
        endTime:'',
        queryType:'',
        type:'',//搜索结果类型
        allCount:0,
        pageIndex:1,
        pageSize:10,
        loading: false,
        finished: false,
        projectList:[],
        cityCode:'410100',
        status: undefined,
        communityId: undefined,
        communityName: '',
        statusName:'',
        showPopup: false,
        selIndex:'',
        columns:[],
        timeList:[
          {name:'近7天',value:7},
          {name:'近30天',value:30},
          {name:'近90天',value:90},
        ],
        typeList:[],
        stopList:[
          {name:'设备故障',value:1},
          {name:'线路故障',value:2},
          {name:'网络欠费',value:3},
          {name:'电表欠费',value:4},
          {name:'暂停使用',value:5},
        ],
        changeItem: null,
        changeIndex: null,
        cityList: [],
        communityList: [],
        activeNames: [],
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Image.name]:Image,
      [Toast.name]:Toast, 
      [Loading.name]:Loading,
      [Field.name]:Field,
      [List.name]:List,
      [search.name]:search,
      [tag.name]:tag,
      [Collapse.name]:Collapse,
      [CollapseItem.name]:CollapseItem,
      [Grid.name]:Grid, 
      [GridItem.name]:GridItem,
      [Switch .name]: Switch,
      [Popup.name]:Popup,
      [Picker.name]:Picker,
    },
     activated(){
      if(this.$route.query.isDetail==1){
        this.projectList=[]
        this.keyword=''
      }
    },
    methods: {
      changePage(item){
        delete this.$route.query.isDetail;
          if(item.queryType == 1){//充值记录
            this.$router.push({path: "rechargeDetail.html",query:{id:item.orderId}})
          }else if(item.queryType == 2){//退款记录
            this.$router.push({path: "refundDetail.html",query:{id:item.orderId}})
          }else if(item.queryType == 3){//充电记录
            this.$router.push({path: "chargeDetail.html",query:{orderId:item.orderId}})
          }
      },
      changePage2(item){
            this.$router.push({path: "deviceDetail.html",query:{id:item.mainNo}})
      },
      onSearch(){
        this.isSearch=true
        this.pageIndex=1;
        this.finished=false;
        this.loading=true
        this.projectList=[];
         setTimeout(() => {
        this.getMoreList();
         })
        
      },
      showPicker(type){
        this.selIndex = type;
        if(type == 1){
          this.showPopup = true;
          this.columns = [
            // 第一列
            {
              values: this.cityList,
              defaultIndex: 0,
            },
            // 第二列
            {
              values: this.communityList,
              defaultIndex: 0,
            },
          ];
        }else if(type == 2){
          this.showPopup = true;
          this.columns = this.timeList;
          
        }else if(type == 3){
          this.showPopup = true;
          this.columns = this.typeList;
        }
      },
      onChange(picker,item, index) {
        if(this.selIndex == 1 && index == 0){
          this.cityCode = item[0].id;
          this.getCommunityList(picker);
        }
      },
      onChangeSwitch(item,index){
        this.selIndex = 4;
        this.changeItem = item;
        this.changeIndex = index;
        this.columns = this.stopList;
        this.showPopup = true;
      },
      onCancel(){
        //取消
        if(this.selIndex == 1){
          // 项目
          this.communityName = '';
          this.communityId = undefined;
        }else if(this.selIndex == 2){
          // 时间
          this.startTime = '';
        }else{
          // 类型
          this.searchType = '';
          this.queryType=''
        }
        this.showPopup = false;
        this.finished=false
          this.projectList=[]
          this.pageIndex=1;
          this.getMoreList();
 
      },
      onConfirm(item) {
        
        if(this.selIndex == 1){
          // 项目
          this.communityName = item[1].name;
          this.communityId = [item[1].id];
        }else if(this.selIndex == 2){
          // 时间
          this.startTime = moment().startOf("day").subtract(item.value, 'days').format('YYYY-MM-DD 00:00:00')
          this.searchTime = item.name;
        }else if(this.selIndex == 3){
          // 类型
          this.searchType = item.name;
          this.queryType=item.value
        }else{
          var index = this.changeIndex;
          this.projectList[index].checked = true;
        }
        this.finished=false
        this.projectList=[]
        this.pageIndex = 1;
        this.getMoreList();
        this.showPopup = false;
      },
      getCityList() {
        axios.get("/common/getcitylist?proviceId=410000").then((res)=>{
          this.cityList = res.data;
        })
      },
      getCommunityList(picker) {
        axios.post("/common/getcommunitylistbycitycode",{
          cityCode: this.cityCode,
        }).then((res)=>{
          if(res.data.length > 0){
            res.data.forEach(item=>{
              item.name = item.communityName
              item.id = item.communityId
            })
          }
          this.communityList = res.data;
          if(picker){
            picker.setColumnValues(1,res.data);
          }
          
        })
      },
      onLoad(){
        // 异步更新数据
        if(this.keyword=='')return
          this.pageIndex++;
          this.getMoreList();
      },
      getMoreList() {
        axios.post("/home/query",{
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          startTime: this.startTime,
          endTime: moment().format("YYYY-MM-DD 23:59:59"),
          keyword: this.keyword,
          communityIds: this.communityId,
          queryType:this.queryType
        }).then((res)=>{
          this.projectList = this.projectList.concat(res.data.list);
          this.allCount = res.data.total;
          this.type=res.data.type;
          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          if (this.pageIndex * this.pageSize >= this.allCount) {
            this.finished = true;
          }
        }).catch(error=>{
          this.loading = false;
          this.finished=true
        })
      },
      onClickLeft() {
        this.$router.replace({path: "home.html"});
      },
      onClickRight() {
      },
      //解析链接方法
      getQueryString(url, name) {
        var reg = new RegExp('(^|&|/?)' + name + '=([^&|/?]*)(&|/?|$)', 'i');
        var r = url.substr(1).match(reg);
        if (r != null) {
          return r[2];
        }
        return null;
      },
      scanQRCode(){
        var that = this;

        // that.finished=false;
        // that.keyword='ISC3211220506001';
        // that.projectList=[];
        // that.pageIndex = 1;
        // that.getMoreList();
        // return
        Vue.wechat.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function (res) {
            console.log(res)
            var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
            let qrUrl = decodeURIComponent(result);
            let mainNo = that.getQueryString(qrUrl, 'mainNo');
            if(mainNo){
                that.finished=false;
                that.keyword=mainNo;
                that.projectList=[];
                that.pageIndex = 1;
                that.getMoreList();
            }else{
              Toast('请扫描设备码');
            }
          },
          fail:function(error){
            Toast(error)
          }
        });
      },
    },
    computed:{
    },
    created () {
      this.getCityList();
      this.getCommunityList();
      //搜索类型
       axios.get("/common/getquerytype",{
        }).then((res)=>{
          this.typeList = res.data;
          this.typeList.forEach(item => {
            item.name = item.description;
            item.value = item.id;
          });
          this.typeList.unshift({
            name:'全部',value:''
          })
        })
    },
    mounted () {},
    destroyed () {}
  }
</script>
<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #F0F4F7}
  .container{
    width: 100%;height: 100%;letter-spacing:0px;background: #F0F4F7;
  }
  .list-box{
    width: 100%;
    color: #373737 !important;
    .list{
      font-size: 14px;
      width: 100%;
      background: #fff;
      margin: 12px 0;
      padding: 12px;
      .lab{
        display: inline-block;
        padding-right: 10px;
      }
      .val{font-size: 18px;}
    }
    .mg10{margin-bottom: 10px;}
    .bold{font-weight: bold;}
  }
  .menu{
    width: 100%;
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fff;
    .menuitem{
      width: 33%;
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      .icon{
        width: 10px;
        height: 6px;
        vertical-align: middle;
      }
    }
  }
  .fg{
    width: 2px;
    height: 16px;
    display: inline-block;
    background: #7BC9FF;
    margin: 0 20px;
    vertical-align: middle;
  }
  .dian{
    width: 8px;
    height: 8px;
    border-radius: 8px;
    display: inline-block;
    vertical-align: middle;
  }
  .mg10{margin-bottom: 10px;}

  .formbox{
    color: #373737 !important;
    margin: 10px 0;
  }
  /deep/.van-search__content {
    background-color: #fff;
  }
  /deep/.van-collapse-item__content{padding: 12px 0;}
  /deep/.van-grid-item__content{
    padding: 8px;
    color: #373737;
    border-radius: 4px;
    background: #e8fcff;
  }

  /deep/.charging .van-grid-item__content{
    color: #fff;
    background: #7BC9FF;
  }
  /deep/.error .van-grid-item__content{
    color: #fff;
    background: #FF4F45;
  }
</style>
